import { WOOFZ_COACHING } from 'nove8/constants/root-constants'
import { getDogsProfile } from 'nove8/helpers/api/getDogsProfile'
import { useEffect, useMemo } from 'react'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetDogsProfile = (): void => {
  const cohort = useZustandStore(
    (state) => state.lead?.cohort || state.initialCohort,
  )
  const language = useZustandSessionStore((state) => state.language)
  const isCoachingCohort = useMemo(() => cohort === WOOFZ_COACHING, [cohort])

  useEffect(() => {
    if (!language || !isCoachingCohort) return

    getDogsProfile()
  }, [cohort, language, isCoachingCohort])
}
